'use client';
var classes = {"root":"m_4addd315","control":"m_326d024a","dots":"m_4ad7767d"};

export { classes as default };
//# sourceMappingURL=Pagination.module.css.mjs.map
